import { clsx } from 'clsx';
import { Fragment, type ReactNode } from 'react';

export interface BreadcrumbItem {
  label: ReactNode;
  href?: string;
  onClick?: () => void;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav
      aria-label="Breadcrumbs"
      className={clsx(
        'inline-flex items-center text-[11px] font-bold uppercase tracking-label text-fg-muted',
        className,
      )}
    >
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        const content = isLast ? (
          <span className="text-fg-primary">{it.label}</span>
        ) : it.href ? (
          <a href={it.href} className="hover:text-fg-primary transition-colors">
            {it.label}
          </a>
        ) : (
          <button
            type="button"
            onClick={it.onClick}
            className="hover:text-fg-primary transition-colors"
          >
            {it.label}
          </button>
        );
        return (
          <Fragment key={i}>
            {content}
            {!isLast && <span className="mx-1.5 opacity-50">›</span>}
          </Fragment>
        );
      })}
    </nav>
  );
}
